export default __webpack_public_path__ + "static/media/menu-white.3e93bdfd.svg";